/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_After_4Inputs */

const en_landing_after_4 = /** @type {(inputs: Landing_After_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS score breakdown shows exactly what to fix`)
};

const de_landing_after_4 = /** @type {(inputs: Landing_After_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-Score zeigt genau, was verbessert werden muss`)
};

const fr_landing_after_4 = /** @type {(inputs: Landing_After_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le détail du score ATS te montre exactement quoi corriger`)
};

const es_landing_after_4 = /** @type {(inputs: Landing_After_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desglose de puntuación ATS que muestra exactamente qué mejorar`)
};

const it_landing_after_4 = /** @type {(inputs: Landing_After_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il punteggio ATS ti mostra esattamente cosa correggere`)
};

const nl_landing_after_4 = /** @type {(inputs: Landing_After_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-scoreuitsplitsing laat precies zien wat je moet verbeteren`)
};

const pl_landing_after_4 = /** @type {(inputs: Landing_After_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozbicie wyniku ATS pokazuje dokładnie, co poprawić`)
};

const fi_landing_after_4 = /** @type {(inputs: Landing_After_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-pisteytys näyttää tarkalleen, mitä korjata`)
};

const da_landing_after_4 = /** @type {(inputs: Landing_After_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-scoreopdeling viser præcis, hvad du skal rette`)
};

const sv_landing_after_4 = /** @type {(inputs: Landing_After_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-poänguppdelning visar exakt vad du ska fixa`)
};

/**
* | output |
* | --- |
* | "ATS score breakdown shows exactly what to fix" |
*
* @param {Landing_After_4Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_after_4 = /** @type {((inputs?: Landing_After_4Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_After_4Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_after_4(inputs)
	if (locale === "fr") return fr_landing_after_4(inputs)
	if (locale === "es") return es_landing_after_4(inputs)
	if (locale === "it") return it_landing_after_4(inputs)
	if (locale === "nl") return nl_landing_after_4(inputs)
	if (locale === "pl") return pl_landing_after_4(inputs)
	if (locale === "fi") return fi_landing_after_4(inputs)
	if (locale === "da") return da_landing_after_4(inputs)
	if (locale === "sv") return sv_landing_after_4(inputs)
	return en_landing_after_4(inputs)
});